/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NotificationBellAlarmIcon16Light } from './NotificationBellAlarmIcon16Light';
import { NotificationBellAlarmIcon16Regular } from './NotificationBellAlarmIcon16Regular';
import { NotificationBellAlarmIcon16Solid } from './NotificationBellAlarmIcon16Solid';
import { NotificationBellAlarmIcon20Light } from './NotificationBellAlarmIcon20Light';
import { NotificationBellAlarmIcon20Regular } from './NotificationBellAlarmIcon20Regular';
import { NotificationBellAlarmIcon20Solid } from './NotificationBellAlarmIcon20Solid';
import { NotificationBellAlarmIcon24Regular } from './NotificationBellAlarmIcon24Regular';
import { NotificationBellAlarmIcon24Solid } from './NotificationBellAlarmIcon24Solid';
import { NotificationBellAlarmIcon32Regular } from './NotificationBellAlarmIcon32Regular';
import { NotificationBellAlarmIcon64Regular } from './NotificationBellAlarmIcon64Regular';
var sizes = {
    16: {
        light: NotificationBellAlarmIcon16Light,
        regular: NotificationBellAlarmIcon16Regular,
        solid: NotificationBellAlarmIcon16Solid,
    },
    20: {
        light: NotificationBellAlarmIcon20Light,
        regular: NotificationBellAlarmIcon20Regular,
        solid: NotificationBellAlarmIcon20Solid,
    },
    24: {
        regular: NotificationBellAlarmIcon24Regular,
        solid: NotificationBellAlarmIcon24Solid,
    },
    32: {
        regular: NotificationBellAlarmIcon32Regular,
    },
    64: {
        regular: NotificationBellAlarmIcon64Regular,
    },
};
export var NotificationBellAlarmIcon = forwardRef('NotificationBellAlarmIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
